"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminInstruction = exports.swapInstruction = exports.initSwapperInstruction = void 0;
const web3_js_1 = require("@solana/web3.js");
const borsh_1 = require("borsh");
const utils_1 = require("./utils");
const spl_token_1 = require("@solana/spl-token");
class initSwapperInstruction {
    constructor(obj) {
        this.tag = 0;
        this.signer_nonce = obj.signer_nonce;
        this.gov_token_per_cope = obj.gov_token_per_cope;
        this.max_quantity_per_wallet = obj.max_quantity_per_wallet;
    }
    serialize() {
        return borsh_1.serialize(initSwapperInstruction.schema, this);
    }
    getInstruction(swapperStateAccount, mintCope, govMint, adminAccount, copeVaultAccount) {
        const data = Buffer.from(this.serialize());
        let keys = [
            {
                pubkey: swapperStateAccount,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: mintCope,
                isSigner: false,
                isWritable: false,
            },
            {
                pubkey: govMint,
                isSigner: false,
                isWritable: false,
            },
            {
                pubkey: adminAccount,
                isSigner: false,
                isWritable: false,
            },
            {
                pubkey: copeVaultAccount,
                isSigner: false,
                isWritable: false,
            },
        ];
        return new web3_js_1.TransactionInstruction({
            keys,
            programId: utils_1.PROGRAM_ID,
            data,
        });
    }
}
exports.initSwapperInstruction = initSwapperInstruction;
initSwapperInstruction.schema = new Map([
    [
        initSwapperInstruction,
        {
            kind: "struct",
            fields: [
                ["tag", "u8"],
                ["signer_nonce", "u8"],
                ["gov_token_per_cope", "u64"],
                ["max_quantity_per_wallet", "u64"],
            ],
        },
    ],
]);
class swapInstruction {
    constructor(obj) {
        this.tag = 1;
        this.copeAmount = obj.copeAmount;
    }
    serialize() {
        return borsh_1.serialize(swapInstruction.schema, this);
    }
    getInstruction(swapperStateAccount, swapperSigner, swapperCopeAccount, swapperGovTokenAccount, claimerCopeAccount, claimerGovTokenAccount, claimerAccount) {
        const data = Buffer.from(this.serialize());
        let keys = [
            {
                pubkey: swapperStateAccount,
                isSigner: false,
                isWritable: false,
            },
            {
                pubkey: swapperSigner,
                isSigner: false,
                isWritable: false,
            },
            {
                pubkey: swapperCopeAccount,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: swapperGovTokenAccount,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: claimerCopeAccount,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: claimerGovTokenAccount,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: claimerAccount,
                isSigner: true,
                isWritable: true,
            },
            {
                pubkey: spl_token_1.TOKEN_PROGRAM_ID,
                isSigner: false,
                isWritable: false,
            },
        ];
        return new web3_js_1.TransactionInstruction({
            keys,
            programId: utils_1.PROGRAM_ID,
            data,
        });
    }
}
exports.swapInstruction = swapInstruction;
swapInstruction.schema = new Map([
    [
        swapInstruction,
        {
            kind: "struct",
            fields: [
                ["tag", "u8"],
                ["copeAmount", "u64"],
            ],
        },
    ],
]);
class adminInstruction {
    constructor(obj) {
        this.tag = 2;
        this.cope_amount_to_withdraw = obj.cope_amount_to_withdraw;
        this.gov_token_amount_to_withdraw = obj.gov_token_amount_to_withdraw;
    }
    serialize() {
        return borsh_1.serialize(adminInstruction.schema, this);
    }
    getInstruction(swapperStateAccount, swapperSigner, swapperCopeAccount, swapperGovTokenAccount, adminCopeAccount, adminGovTokenAccount, adminAccount) {
        const data = Buffer.from(this.serialize());
        let keys = [
            {
                pubkey: swapperStateAccount,
                isSigner: false,
                isWritable: false,
            },
            {
                pubkey: swapperSigner,
                isSigner: false,
                isWritable: false,
            },
            {
                pubkey: swapperCopeAccount,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: swapperGovTokenAccount,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: adminCopeAccount,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: adminGovTokenAccount,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: adminAccount,
                isSigner: true,
                isWritable: true,
            },
            {
                pubkey: spl_token_1.TOKEN_PROGRAM_ID,
                isSigner: false,
                isWritable: false,
            },
        ];
        return new web3_js_1.TransactionInstruction({
            keys,
            programId: utils_1.PROGRAM_ID,
            data,
        });
    }
}
exports.adminInstruction = adminInstruction;
adminInstruction.schema = new Map([
    [
        adminInstruction,
        {
            kind: "struct",
            fields: [
                ["tag", "u8"],
                ["cope_amount_to_withdraw", "u64"],
                ["gov_token_amount_to_withdraw", "u64"],
            ],
        },
    ],
]);
//# sourceMappingURL=instructions.js.map